import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import DOMPurify from 'dompurify'
import usePost from 'hooks/usePost'
// import { LoaderContext } from 'context/loader'
import APIS from 'constants/api'
import { NotFoundRoute } from 'constants/routes'
import BackArrow from 'assets/svg/BackArrow'
import { BackWrapper } from 'styles/pages/Login'
import { TermsWrappers, ContactUsContainer, DataWrapper, ContactUsDescription } from 'styles/pages/NotFound'

const ContactUs = () => {
  const router = useHistory()
  // const { setLoader } = useContext(LoaderContext)
  const [termsData, setTermsData] = useState<any>(null || '')

  const { mutateAsync } = usePost()

  const fetchData = async (pageUrl: string) => {
    //setLoader(true)
    try {
      const res = await mutateAsync({
        url: APIS.DYNAMICURL,
        payload: {
          pageUrl: pageUrl,
          customerId: false,
          sortBy: {},
        },
      })
      if (res) {
        //setLoader(false)
        setTermsData(res?.d?.sections[0]?.widgets)
      }
    } catch (error: any) {
      //setLoader(false)
      router.push(NotFoundRoute.path)
      return error
    }
  }

  const handleBack = () => {
    router.goBack()
  }

  useEffect(() => {
    const path = location.pathname.split('/').pop() // Extract the last segment of the path
    const plotchDomain =
      process.env.NODE_ENV == 'production' && process.env.REACT_APP_ENV == ''
        ? window.location.hostname
        : process.env.REACT_APP_PLOTCH_DOMAIN
    if (path) {
      fetchData(`http://${plotchDomain}/${path}`)
    }
  }, [location.pathname])

  const addFormAssets = () => {
    const assets: Array<{ type: 'link' | 'script'; href?: string; src?: string }> = [
      { type: 'link', href: 'https://cdn1.plotch.io/assets/css/form_1630673015.css' },
      { type: 'link', href: 'https://cdn1.plotch.io/assets/css/bootstrap.min.css' },
      { type: 'script', src: 'https://cdn1.plotch.io/assets/js/jquery-2.2.4.min.js' },
      { type: 'script', src: 'https://cdn1.plotch.io/assets/js/bootstrap.min.js' },
      { type: 'script', src: 'https://cdn1.plotch.io/assets/js/jquery-ui.min.js' },
      { type: 'script', src: 'https://cdn1.plotch.io/assets/js/jquery.validate.min.js' },
      { type: 'script', src: 'https://cdn1.plotch.io/assets/js/plotchForm_builder_1717765442.js' },
    ]

    const loadScript = (index: number) => {
      if (index >= assets.length) return // All assets loaded
      const asset = assets[index]
      if (!asset.src && !asset.href) return // Ensure either src or href is defined
      const element = asset.type === 'link' ? document.createElement('link') : document.createElement('script')
      element.onload = () => loadScript(index + 1) // Load the next script once this one is loaded
      if (asset.src) {
        ;(element as HTMLScriptElement).src = asset.src
      } else if (asset.href) {
        ;(element as HTMLLinkElement).href = asset.href
        ;(element as HTMLLinkElement).rel = 'stylesheet' // Set rel attribute for link elements
      }

      document.head.appendChild(element)
    }

    loadScript(0)
  }

  return (
    <>
      <TermsWrappers>
        <BackWrapper onClick={handleBack}>
          <BackArrow />
          Contact Us
        </BackWrapper>
        <ContactUsContainer>
          {termsData &&
            termsData.map((term: any, index: number) => {
              if (term.type === '_editor' && term.elements[0]?.data) {
                return (
                  <ContactUsDescription
                    key={index}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(term.elements[0].data) }}
                  />
                )
              }

              if (term.type === '_form' && term.elements[0]?.formData) {
                addFormAssets()
                return (
                  <DataWrapper
                    key={index}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(term.elements[0].formData) }}
                  />
                )
              }

              if (term.type === '_space_card' && term.elements[0]?.data) {
                return <div key={index} style={{ width: term.elements[0].data }} />
              }

              return null
            })}
        </ContactUsContainer>
      </TermsWrappers>
    </>
  )
}

export default ContactUs
